import { useEffect } from 'react';
import { BETA_REF, IS_BETA } from '../utils/channel';

// 🧪 베타 채널 표시 (2026-09-28 사용자 "베타버전인지 여부도 표시되면 좋겠네") — 좌하단 작은 알약 + 창 제목 앞 [BETA].
//   운영에선 IS_BETA=false 라 아무것도 렌더하지 않는다. 클릭을 가로채지 않게 pointer-events:none.
//   색은 테마 브릿지(블랙 테마 일괄 치환)를 타지 않도록 인라인 — 흰 글자 대비 5:1(#B45309).
const PREFIX = '[BETA] ';

export default function BetaBadge() {
	useEffect(() => {
		if (!IS_BETA) return;
		const apply = () => { if (!document.title.startsWith(PREFIX)) document.title = PREFIX + document.title; };
		apply();
		// 화면마다 document.title 을 새로 쓰므로(팝아웃 등) <title> 변경을 따라가며 다시 붙인다
		const el = document.querySelector('title');
		if (!el) return;
		const mo = new MutationObserver(apply);
		mo.observe(el, { childList: true, characterData: true, subtree: true });
		return () => mo.disconnect();
	}, []);
	if (!IS_BETA) return null;
	return (
		<div
			data-testid="beta-badge"
			aria-hidden="true"
			style={{ position: 'fixed', left: 8, bottom: 8, zIndex: 2147483000, pointerEvents: 'none', background: '#B45309', color: '#fff', fontSize: 10, fontWeight: 700, lineHeight: '16px', padding: '0 7px', borderRadius: 999, letterSpacing: 0.4, opacity: 0.9 }}
		>
			BETA{BETA_REF && BETA_REF !== 'web' && BETA_REF !== 'desktop' ? ` · ${BETA_REF.slice(0, 7)}` : ''}
		</div>
	);
}
